package app.nestbridge.feature.careteam.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.domain.identity.model.ProfessionalServiceType
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class CreateCareTeamScreen(
    // TODO: This should always have a childId - update TeamCreationLandingPresenter and CreateProfessionalProfilePresenter to pass it
    val childId: String = "",
) : Screen

data class CreateCareTeamState(
    val child: app.nestbridge.feature.children.model.Child?,
    val careTeamType: ProfessionalServiceType?,
    val description: String,
    val isLoading: Boolean,
    val isSaving: Boolean,
    val eventSink: (CreateCareTeamEvent) -> Unit,
) : CircuitUiState

sealed interface CreateCareTeamEvent {
    data object OnAppear : CreateCareTeamEvent
    data object Back : CreateCareTeamEvent
    data object Submit : CreateCareTeamEvent
    data class UpdateCareTeamType(val value: ProfessionalServiceType) : CreateCareTeamEvent
    data class UpdateDescription(val value: String) : CreateCareTeamEvent
}

fun CreateCareTeamState.canSubmit(): Boolean =
    child != null && careTeamType != null && !isSaving

@Parcelize
data class TeamCreationResult(
    val status: Status,
) : PopResult {
    enum class Status { Completed, Cancelled }
}